<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'repasses' ? 'active' : ''" @click.prevent="abrir('repasses')">
                        <i class="fas fa-hand-holding-usd mr-2"></i>
                        Repasses
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'rateios' ? 'active' : ''" @click.prevent="abrir('rateios')" >
                        <i class="fas fa-percent mr-2"></i>
                        Rateios
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'apuracao' ? 'active' : ''" @click.prevent="abrir('apuracao')" >
                        <i class="fas fa-play mr-2"></i>
                        Apuração
                    </a>
                </li>
                <li class="nav-item" v-if="false">
                    <a class="nav-link" href="#" :class="aba == 'validacao' ? 'active' : ''" @click.prevent="abrir('validacao')" >
                        <i class="fas fa-check-double mr-2"></i>
                        Validação
                    </a>
                </li>
            </ul>
        </div>

        <repasses v-if="aba == 'repasses'" />
        <rateios v-if="aba == 'rateios'" />
        <simula-apuracao v-if="aba == 'apuracao'" />
        <validacao-repasse v-if="aba == 'validacao'" />
    </div>
</template>

<script>
import Repasses from './Repasses.vue';
import Rateios from './Rateios.vue';
import ValidacaoRepasse from './ValidacaoRepasse.vue';
import SimulaApuracao from './SimulaApuracao.vue';

export default {
    data() { 
        return { 
            // aba: 'repasses',
        }
    },

    props: ['aba'], 

    components: { 
        Repasses,
        Rateios, 
        ValidacaoRepasse, 
        SimulaApuracao, 
    },

    methods: { 
        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/repasse/' + aba });
            }
        },
    }
}
</script>